import {inject, Injectable, OnDestroy} from "@angular/core";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslateService} from "@ngx-translate/core";
import {Subject, Subscription} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CustomPaginatorIntl implements MatPaginatorIntl, OnDestroy {
    private readonly translateService: TranslateService = inject(TranslateService);
    private readonly langChangeSubscription: Subscription;

    public readonly changes = new Subject<void>();
    public firstPageLabel = '';
    public itemsPerPageLabel = '';
    public lastPageLabel = '';
    public nextPageLabel = '';
    public previousPageLabel = '';

    constructor() {
        this.updateLabels();
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
            this.updateLabels();
            this.changes.next();
        });
    }

    public ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    public getRangeLabel(page: number, pageSize: number, length: number): string {
        const startIndex = page * pageSize;
        const endIndex = startIndex + pageSize;
        return this.translateService.instant("components.paginator.currentPageNumber", {
            firstItemIndex: length > 0 ? startIndex + 1 : 0,
            secondItemIndex: endIndex <= length ? endIndex : length,
            totalAmountOfItems: length
        });
    }

    private updateLabels(): void {
        this.firstPageLabel = this.translateService.instant("components.paginator.firstPage");
        this.itemsPerPageLabel = this.translateService.instant("components.paginator.itemsPerPage");
        this.lastPageLabel = this.translateService.instant("components.paginator.lastPage");
        this.nextPageLabel = this.translateService.instant("components.paginator.nextPage");
        this.previousPageLabel = this.translateService.instant("components.paginator.previousPage");
    }
}
